export default "__VITE_ASSET__DTHf$dWB__"